export default __webpack_public_path__ + "static/media/m_highway.8b48f43a.png";